module.exports = __webpack_public_path__ + "img/arche.c0277a7e.svg";